"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'auth';
exports.SET_ACCESS_TOKEN = exports.namespace + "/SET_ACCESS_TOKEN";
exports.SET_USER = exports.namespace + "/SET_USER";
exports.LINK_ACCOUNT = exports.namespace + "/LINK_ACCOUNT";
exports.OPT_OUT = "auth/newSkyGo/OPT_OUT";
exports.UNAUTHORIZED_ERROR = exports.namespace + "/UNAUTHORIZED_ERROR";
exports.FETCH_CONFIG = exports.namespace + "/FETCH_CONFIG";
exports.SET_AUTH_LOADING = exports.namespace + "/SET_AUTH_LOADING";
//# sourceMappingURL=constants.js.map